import * as React from "react"
import { Skeleton, Typography } from "@mui/material"

import { TitleWithPopover, AppTableSeeker } from "@components"
import { useToast } from "@hooks"
import { isLoadingCommonFilters } from "@signals"
import { useStockChangesSearch } from "./@hooks"
import { CreateReportButton } from "./actions"
import { diffColumn, pricesColumn, retailerColumn, sellerColumn, skuColumn, stockStatusColumn } from "./columns"
import { useStockChangesRoleConfig } from "../@hooks"


const HEIGHT = 500

export default function StockChangesTable() {

	const { stockChangesData, stockChangesIsEmpty } = useStockChangesSearch()
	const { showToast } = useToast()
	const { isMarketplacesUser, isRetailerUser, userUseRRSP, urlApiExcel } = useStockChangesRoleConfig()

	if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (stockChangesIsEmpty) return <Typography variant="h5" sx={{ mt: 4, textAlign: 'center'}}> There doesn’t seem to be much variation in stock levels for the chosen dates. </Typography>
	if (!stockChangesData?.length) return <></>

	return <AppTableSeeker
		title={<TitleWithPopover title="Stock Changes" />}
		data={stockChangesData}
		columns={[
			...retailerColumn(),
			...skuColumn(),
			...isMarketplacesUser ? [...sellerColumn()] : [],
			stockStatusColumn('prevStock', 'Previous Stock Status', 'prevStockColor', 'prevNumVariants', false),
			stockStatusColumn('stock', 'Stock Status', 'stockColor', 'numVariants', true),
			...!isMarketplacesUser ? [pricesColumn('price', 'Price')] : [],
			...!isMarketplacesUser && userUseRRSP ? [pricesColumn('myPrice', isRetailerUser ? 'My Price' : 'RRSP')] : [],
			...!isMarketplacesUser && userUseRRSP ? [diffColumn(isRetailerUser ? 'Diff vs My Price' : 'Diff vs RRSP')] : []
		]}
		options={{
			onDownload: () => showToast.promiseExcel(urlApiExcel),
			customToolbar: () => <CreateReportButton />,
			enhancedSetRowProps: () => ({ sx: {
				"&:has(.is-open)": {backgroundColor: "primary.light"}
			} })
		}}
	/>
}